<template>
    <div>

        <!-- button -->
        <b-button v-b-modal.createBankroll>
            {{ __('configuration.New Bankroll') }}
        </b-button>

        <!-- createBankroll -->
        <b-modal
            id="createBankroll"
            size="md"
            hide-header
            hide-footer>
            <!-- Loading -->
            <b-overlay :show="form.busy">

                <!-- Form -->
                <form @submit.prevent="submit" novalidate="true">

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Name')">
                        <b-form-input
                            v-model="form.name"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                        ></b-form-input>
                        <has-error :form="form" field="name"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Initial Balance')">
                        <currency-input
                            :locale="locale"
                            :currency='currency'
                            class="form-control font-weight-bold"
                            v-bind:class="{'is-invalid': form.errors.has('initial_balance'), 'text-muted': form.initial_balance === 0, 'text-success': form.initial_balance > 0, 'text-danger': form.initial_balance < 0}"
                            v-model="form.initial_balance"
                        />
                        <has-error :form="form" field="initial_balance"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Currency')">
                        <select v-model="form.currency" class="form-control" :class="{ 'is-invalid': form.errors.has('currency') }">
                            <option value="1">Dollar ($)</option>
                            <option value="2">Euro (€)</option>
                            <option value="3">Sterling Pound (£)</option>
                            <option value="4">Brazillian Real (R$)</option>
                            <option value="5">Rand (R)</option>
                            <option value="6">Bitcoin (BTC)</option>
                            <option value="7">Corona Sueca</option>
                            <option value="8">Swiss Francs</option>
                        </select>
                        <has-error :form="form" field="currency"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Initial Date')">
                        <b-form-datepicker
                            v-model="form.initial_date"
                            :class="{ 'is-invalid': form.errors.has('initial_date') }"
                            :locale="locale"
                            placeholder="">
                        </b-form-datepicker>
                        <has-error :form="form" field="initial_date"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Commission')">
                        <b-input-group append="%">
                            <b-form-input
                                v-model="form.commission"
                                :class="{ 'is-invalid': form.errors.has('commission') }"
                                type="number"
                            ></b-form-input>
                        </b-input-group>
                        <has-error :form="form" field="commission"></has-error>
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disabled="form.busy">
                        {{ __('configuration.New Bankroll') }}
                    </b-button>

                </form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    props: ['locale', 'currency'],
    data() {
        return {
            loading: false,
            form: new Form({
                name: null,
                initial_balance: 0,
                currency: 1,
                initial_date: new Date(),
                commission: 0,
            })
        }
    },
    methods: {
        submit() {
            this.form.post('/' + this.locale + '/configurations/bankrolls')
                .then(result => {
                    this.$bvModal.hide('createBankroll')
                    this.$emit('created')
                    window.location.reload();
                })
        }
    }
}
</script>

<style scoped>

</style>
